import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../utils/formatCurrency';
import { useUserData } from '../api/queryHooks/user';

export interface UseCurrencyResult {
  format: (value: number | string | null | undefined) => string;
  currencyCode: string;
}

/**
 * Hook to access currency formatting based on the current account's settings.
 * Falls back to EUR when not logged in. Precision is driven by the currency
 * itself (HUF → 0, EUR → 2 …); see formatCurrency.
 */
export const useCurrency = (): UseCurrencyResult => {
  const { i18n } = useTranslation();
  const { data: userData } = useUserData();

  const currencyCode = userData?.account?.currency_code || 'EUR';

  const format = (value: number | string | null | undefined): string =>
    formatCurrency(value, currencyCode, i18n.language);

  return { format, currencyCode };
};

export default useCurrency;
